import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import {validacionWalmart} from "../endpoints";
import {Autocomplete} from "@material-ui/lab";

class DialogAgregarEditarRNR extends React.Component{
    constructor(props) {
        super(props);
        if(props.depto === null){
            this.state={
                title:'Agregar RNR',
                depto:null ,
                cantidad: '',
                importe:'',
                deptos:[]
            }
        }
        else{
            this.state={
                id:props.id,
                title:'Editar RNR',
                depto:null,
                cantidad: props.cantidad,
                importe:props.importe,
                deptos:[]
            }
        }
    }

    componentDidMount() {
        this.getDeptosWalmart()
    }

    handleChange = (event) => {
        this.setState({[event.target.name]: event.target.value})
    };

    agregarRNR= () =>{
        validacionWalmart.createRnr(this.state.depto.descripcion, this.state.cantidad, this.state.importe).then(async response => {
            if (response) {
                return await response.json();
            }
        }).then(result=> {
            if(result.message){
                this.props.refrescar(result.message,result.severity)
            }
            else{
                throw new Error('Something went wrong ...');
            }
        }).catch(error=> {
            console.log(error)
            this.props.refrescar("Ha ocurrido un error inesperado", "error")
        });
    }

    editarRNR= () =>{
        validacionWalmart.updateRnr(this.state.id, this.state.depto.descripcion, this.state.cantidad, this.state.importe).then(async response => {
            if (response) {
                return await response.json();
            }
        }).then(result=> {
            if(result.message){
                this.props.refrescar(result.message,result.severity)
            }
            else{
                throw new Error('Something went wrong ...');
            }
        }).catch(error=> {
            console.log(error)
            this.props.refrescar("Ha ocurrido un error inesperado", "error")
        });
    }


    getDeptosWalmart (){
        validacionWalmart.getDeptosWalmart().then(async response => {
            if (response.ok) {
                return await response.json();
            } else {
                throw new Error('Something went wrong ...');
            }
        }).then(result => {
            if(result.status_code === 200){
                this.setState({deptos:result.deptos}, ()=>{
                    if(this.state.depto !== ""){
                        for (let i = 0; i < result.deptos.length; i++) {
                            if(result.deptos[i].descripcion=== this.props.depto){
                                this.setState({depto:result.deptos[i]})
                            }
                        }
                    }
                })


            }
            else{
                throw new Error('Something went wrong ...');
            }
        }).catch(error=> {
            console.log(error)
        });
    }


    render() {
        return(
            <Dialog
                open={true}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">{this.state.title}</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2} alignItems="flex-end">
                        <Grid item xs={12}>
                            <Autocomplete
                                id="size-small-standard"
                                onChange={(event, newValue) => {
                                    if(newValue === null) {
                                        this.setState({depto: ""})
                                    }
                                    else{
                                        this.setState({depto: newValue})
                                    }
                                }}
                                size="small"
                                value={this.state.depto}
                                options={this.state.deptos}
                                noOptionsText={"No hay opciones"}
                                getOptionLabel={(option) => option.descripcion|| ""}
                                renderInput={(params) => (
                                    <TextField {...params} variant="standard" label="Depto." placeholder="Disponibles" />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            Cantidad: <TextField value={this.state.cantidad} type={'number'}  name="cantidad" fullWidth onChange={this.handleChange}/>
                        </Grid>
                        <Grid item xs={12}>
                            Importe: <TextField value={this.state.importe} type={'number'} name="importe" fullWidth onChange={this.handleChange}/>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" color="secondary" onClick={this.props.handleClose}>
                        Cancelar
                    </Button>
                    {
                        this.state.title === "Editar RNR" && <Button disabled={!this.state.depto || !this.state.cantidad || !this.state.importe} variant="contained" color="primary"  onClick={this.editarRNR}>
                            Guardar
                        </Button>
                    }
                    {
                        this.state.title === "Agregar RNR" && <Button disabled={!this.state.depto || !this.state.cantidad || !this.state.importe} variant="contained" color="primary" onClick={this.agregarRNR}>
                            Guardar
                        </Button>
                    }
                </DialogActions>
            </Dialog>
        )
    }
}

export default DialogAgregarEditarRNR;